<template>
  <div data-view="promotions">
    <!-- route to popup [[src/components/dialog/events/Promotion.vue]] -->
    <!-- All popups will appear here -->
    <router-view v-slot="slotProps">
      <component :is="slotProps?.Component" @saved="onSaved" />
    </router-view>

    <layout-logged-frame :title="$t('event_promotion')">
      <template v-slot:header-actions>
        <v-btn
          color="primary"
          @click="openNewEventPromotionModal"
        >
          <v-icon> add </v-icon>
          {{ $t('new_event_promotion') }}
        </v-btn>
      </template>

      <template v-slot:content>
        <PromotionFilters
          @filter="onFilter"
          @clearFilters="onClearFilters"
        />

        <PromotionsTable
          :items="promotions"
          :pagination="pagination"
          :is-loading="isLoading"
          :pages="totalPages"
          :on-select-item="selectItem"
          :on-update-pagination="onUpdatePagination"
          :sync-to-url="true"
          @init-pagination="onInitPagination"
          :on-change-page="onChangePage"
        />
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
import { isStr } from '@/utils';
import PromotionFilters from '../../components/forms/filters/events/Promotion';
import urlPaginationRestore from '@/mixins/urlPaginationRestore';
import PromotionsTable from '../../components/table/events/Promotions';

export default {
  mixins: [urlPaginationRestore],
  components: {
    PromotionFilters,
    PromotionsTable,
  },
  data() {
    return {
      pagination: {
        order: 'desc' ,
        page: 1,
        rowsPerPage: 15,
        perPage: 15,
        sortBy: 'created_at',
        totalItems: 0,
        search: '',
      },
      totalPages: 0,
      query: {
        per_page: 15,
      },
      isLoading: false,
    };
  },
  computed: {
    promotions() {
      return this.$store.getters['events/promotions'];
    },
  },
  methods: {
    getPromotions() {
      this.isLoading = true;
      this.pagination.order = this.query.order;

      return this.$store
        .dispatch('events/getPromotions', this.query)
        .then((res) => {
          const { total, current_page, last_page } = res.promotionsMeta;

          this.pagination.page = current_page;
          this.pagination.lastPage = last_page;
          this.pagination.totalItems = total;
          this.totalPages = last_page;
          this.isLoading = false;

          return res;
        })
        .catch((err) => {
          this.isLoading = false;
          return err;
        });
    },
    selectItem(promotion) {
      this.$store.dispatch('events/setActivePromotion', promotion).then(() => {
        if (promotion.type.id === 1) {
          this.$router.push({name: 'event-promotion-details-theming', params: {id: promotion.id}, query: this.$route.query});
        } else {
          this.$router.push({name: 'event-promotion-details-banner', params: {id: promotion.id}, query: this.$route.query});
        }
      });
    },
    onUpdatePagination({ page, order, sortBy }) {
      const { query, pagination } = this;
      this.pagination.order = order;
      this.pagination.sortBy = isStr(sortBy) ? sortBy : pagination.sortBy;

      const nextQuery = {
        ...query,
        page,
        order,
        sort: isStr(sortBy) ? sortBy : pagination.sortBy,
      };

      this.query = nextQuery;
      this.runInitialFetch(() => this.getPromotions());
    },
    onChangePage(page) {
      const { query, pagination } = this;
      const { order, sortBy } = pagination;
      const nextQuery = {
        ...query,
        page,
        order,
        sort: sortBy,
      };

      this.query = nextQuery;
      this.getPromotions();
    },
    onFilter(filters) {
      this.query = {
        ...this.query,
        page: 1,
        ...filters,
      };

      this.runInitialFetch(() => this.getPromotions());
    },
    onClearFilters() {
      const { sortBy } = this.pagination;
      this.query = {
        sort: sortBy,
        page: 1,
        order: 'desc',
        per_page: 15,
      };
      this.getPromotions();
    },
    openNewEventPromotionModal() {
      this.$router.push({ name: 'event-promotion-new', query: this.$route.query });
    },
    // Emitted by the dialog routes after a successful save. Keeps the
    // refetch in this view, with this view's own query, and out of the URL.
    onSaved() {
      this.isLoading = true;
      this.getPromotions();
    },
  },
};
</script>

<style lang="scss">
@use '../../assets/styles/theme' as *;

[data-view='promotions'] {
  .trigger.download-pdf {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .v-icon {
      margin: 0 6px 0 0;
    }
  }

  .v-datatable {
    min-width: $table-min-width;
  }
}
</style>
